<template>
<v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x >
    <template v-slot:activator="{ on, attrs }">
      <v-badge color='info' right overlap>
        <template v-slot:badge>
          <span v-if='selected && selected.length > 0' v-text='selected.length' />
        </template>
        <v-btn dark outline v-bind="attrs" v-on="on" >
          <v-icon class='mr-2' >{{ctaIcon}}</v-icon>
          {{cta}}
        </v-btn>
      </v-badge>
    </template>
    <v-card>
      <v-system-bar >
        Filter results
        <v-spacer></v-spacer>
        <v-btn @click='menu=false' icon ><v-icon>close</v-icon></v-btn>
      </v-system-bar >
      <v-divider />
      <v-treeview dense selectable
        @input='emitSelected'
        v-model='selected'
        selection-type='independent'
        :items='spaces' />
      <!-- <pre v-text='selected' /> -->
    </v-card>
</v-menu>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SpaceAndLocationFilter',
  props: {
    cta: { type: String, default: 'Filters' },
    ctaIcon: { type: String, default: 'filter_list' }
  },
  data () {
    return {
      menu: false,
      selected: []
    }
  },
  methods: {
    emitSelected (selected) {
      let spaces = []
      let locations = []
      selected.forEach((item) => {
        if (item.startsWith && item.startsWith('space-')) {
          spaces.push(parseInt(item.substring(6)))
        } else {
          locations.push(item)
        }
      })
      this.$emit('input', {spaces, locations})
    }
  },
  computed: {
    ...mapGetters(['lookups']),
    spaces () {
      if (this.lookups && this.lookups.spaces) {
        let spaces = Object.values(this.lookups.spaces)
        return spaces.map((space) => {
          return {
            id: 'space-' + space.id,
            name: space.title,
            children: space.locations
          }
        })
      }
      return []
    },
    items () {
      return [
        {
          id: 1,
          name: 'Applications :',
          children: [
            { id: 2, name: 'Calendar : app' },
            { id: 3, name: 'Chrome : app' },
            { id: 4, name: 'Webstorm : app' }
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// SpaceAndLocationPicker.vue?2e66e922